import React from 'react';
import { DateTime } from 'luxon';

import { narrowHeaderFooterMargins, normalHeaderFooterMargins } from '../margins';
import { EFooterAlignment, EFontFamily, EMarginSize, getFontFamilyCss } from '../types';

export type IExportPdfFooter = {
  displayTimestamp: boolean;
  displayPageNumber: boolean;
  dateTime: DateTime;
  marginSize: EMarginSize;
  note: string;
  displayNote: boolean;
  displayFooter: boolean;
  fontFamily: EFontFamily;
  pageNumberAlignment: EFooterAlignment;
  noteAlignment: EFooterAlignment;
  timestampAlignment: EFooterAlignment;
};

export const dateTimeFormat = `DDD t`;

export const ExportPdfFooter: React.FC<IExportPdfFooter> = (props) => {
  const {
    displayPageNumber,
    displayTimestamp,
    dateTime,
    displayNote,
    note,
    displayFooter,
    pageNumberAlignment,
    noteAlignment,
    timestampAlignment,
    fontFamily
  } = props;

  const timestampElement = displayTimestamp && (
    <time dateTime={dateTime.toFormat('DDD t')}>{dateTime.toFormat('DDD t')}</time>
  );

  const pageNumberElement = displayPageNumber && (
    <div data-test="pdf-page-number-container">
      Page <span className="pageNumber"></span> of <span className="totalPages"></span>
    </div>
  );

  const noteElement = displayNote && <div data-test="pdf-page-note-container">{note}</div>;

  const renderColumn = (alignment: EFooterAlignment) => (
    <div key={alignment} style={{ flex: 1, textAlign: alignment }}>
      {noteAlignment === alignment && noteElement}
      {timestampAlignment === alignment && timestampElement}
      {pageNumberAlignment === alignment && pageNumberElement}
    </div>
  );

  // font size appears to be translated by puppeeter for header/footer
  // 6pt becomes ~8pt
  return (
    <>
      {displayFooter && (
        <footer
          data-test="pdf-footer-container"
          className="footer"
          style={{
            fontSize: '9px',
            fontFamily: getFontFamilyCss(fontFamily),
            fontWeight: 400,
            lineHeight: '12pt',
            width: '100%',
            ...(props.marginSize === EMarginSize.narrow
              ? {
                  marginLeft: narrowHeaderFooterMargins['margin-left'],
                  marginRight: narrowHeaderFooterMargins['margin-right']
                }
              : {
                  marginLeft: normalHeaderFooterMargins['margin-left'],
                  marginRight: normalHeaderFooterMargins['margin-right']
                }),
            left: 0,
            right: 0
          }}
        >
          <div style={{ display: 'flex', width: '100%' }}>{Object.values(EFooterAlignment).map(renderColumn)}</div>
        </footer>
      )}
    </>
  );
};
